export default "__VITE_ASSET__BCO0a5vn__"